import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { InputSwitch } from 'primereact/inputswitch';

import ThemeSwitcher from 'components/ThemeSwitcher';

const ChatterSettings = (props) => {
  const [chatterSettings, setChatterSettings] = useState(null);

  useEffect(() => {
    setChatterSettings(props.chatterSettings ?? null);
  }, [props]);

  const updateSettings = (settingName, settingValue) => {
    const updatedChatterSettings = {
      ...chatterSettings,
      [settingName]: settingValue
    };
    props.onUpdateChatterSettings(updatedChatterSettings);
    setChatterSettings(updatedChatterSettings);
  };

  return (
    <>
      <div className="settings-container flex flex-column gap-3">
        <div className="setting-item flex flex-row align-items-center justify-content-between">
          <div className="left flex flex-row align-item-center justify-content-start">
            外觀模式
          </div>
          <div className="right flex flex-row align-item-center justify-content-end">
            <ThemeSwitcher />
          </div>
        </div>
        {chatterSettings?.classic_message_layout !== undefined &&
          <div className="setting-item flex flex-row align-items-center justify-content-between">
            <div className="left flex flex-row align-item-center justify-content-start">
              經典聊天訊息版面
            </div>
            <div className="right flex flex-row align-item-center justify-content-end">
              <InputSwitch checked={chatterSettings?.classic_message_layout} onChange={(e) => updateSettings('classic_message_layout', e.value)} />
            </div>
          </div>
        }
        <div className="setting-item flex flex-row align-items-center justify-content-between">
          <div className="left flex flex-row align-item-center justify-content-start">
            <div style={{ fontSize:'0.5rem' }}>
              v{process.env.REACT_APP_MODE}
            </div>
          </div>
          <div className="right flex flex-row align-item-center justify-content-end">
            <Button label="登出" className="button-2xs" severity="danger" onClick={props.onLogout} />
          </div>
        </div>
      </div>
    </>
  );
};
  
export default ChatterSettings;


